import React from 'react';
import scriptLoader from 'react-async-script-loader';
import GoogleMapsStyle from './googleMapsStyle';

class Maps extends React.Component {
    constructor( props ) {
        super( props );
        this.mapRef = React.createRef();
        this.map    = null;
    };

    UNSAFE_componentWillReceiveProps( { isScriptLoaded, isScriptLoadSucceed } ) {
        var map;
        const address_latlng = new window.google.maps.LatLng( -36.9111038360462, 174.9358871272578 );

        if ( isScriptLoadSucceed ) {
            map = new window.google.maps.Map( this.mapRef.current, {
                center: address_latlng,
                zoom: 19,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                styles: GoogleMapsStyle
            });

            new window.google.maps.Marker({
                position: address_latlng,
                map,
                title: "Botany Physio",
            });
        } else this.props.onError();
    };

    render() {
        return (
            <div id="google-maps" className="footer-no-border" ref={ this.mapRef }></div>
        );
    };
};

export default scriptLoader( ['https://maps.googleapis.com/maps/api/js?key='+process.env.REACT_APP_GOOGLE_GEOCODING] )( Maps );
